import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';

export const FirstMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', paddingTop: '15px' }}>
                <Typography>
                    <div style={{ textAlign: 'center' }}>
                        <h2>{translations.intro.INTRO_MESSAGE_1_TITLE}</h2>
                    </div>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>
                            <b>{translations.intro.INTRO_MESSAGE_1_LINE_1_1}</b>
                            {translations.intro.INTRO_MESSAGE_1_LINE_1_2}
                        </li>
                        <li>
                            <b>{translations.intro.INTRO_MESSAGE_1_LINE_2}</b>
                        </li>
                        <li>
                            <b>{translations.intro.INTRO_MESSAGE_1_LINE_3_1}</b>
                            {translations.intro.INTRO_MESSAGE_1_LINE_3_2}
                        </li>
                        <li>
                            {translations.intro.INTRO_MESSAGE_1_LINE_4_1}
                            <b>{translations.intro.INTRO_MESSAGE_1_LINE_4_2}</b>
                        </li>
                    </ul>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <div></div>
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
